import React from 'react';
import { Button } from '@cokitchen/cokitchen-components';
import { ReactComponent as Pointer } from 'assets/icons/pointer.svg';
import { ReactComponent as AssignModalIcon } from 'assets/icons/assign-modal-icon.svg';
import './styles.scss';
import { Link } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';
import LocalModal from 'components/base/local-modal';
import { apiService } from 'services/base.service';
import useDashboardContext from 'contexts/dashboard.context';
import { handleApiError } from 'utils/functions';
import { ENUM_ONBOARDING_STATUS, ENUM_ONBOARDING_STEP } from 'utils/enum';

const AssignAdminModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  const { activeCompany, refetchActiveCompany } = useDashboardContext();
  const info = [
    'From the members section, select an employee you want to assign as admin and tap the ‘edit’ icon',
    'From the employee details page, toggle the ‘assign as admin’ switch, to assign admin priviledges to an employee',
    'You may assign additional admins by repeating the steps above, but make sure not to exceed the maximum limit o 10 admins',
    'Each assigned admin will receive an invitation via email to confirm their new role and access the company’s dashboard'
  ];

  const skipStep = async () => {
    try {
      await apiService.put(`company/${activeCompany.id}/onboarding`, {
        data: {
          step: ENUM_ONBOARDING_STEP.ASSIGN_ADMIN,
          status: ENUM_ONBOARDING_STATUS.SKIPPED
        }
      });
      refetchActiveCompany();
    } catch (error) {
      handleApiError(error);
    } finally {
      onClose();
    }
  };

  return (
    <LocalModal
      title=''
      isOpen={isOpen}
      onRequestClose={onClose}
      footer={
        <div className='flex gap-5 justify-end'>
          <Button
            small
            variant='block'
            color='gray'
            onClick={skipStep}
            className='w-[139px] h-[41px] mt-8 text-sm'>
            Skip
          </Button>
          <Link to={`/${ROUTE_KEYS.PEOPLE}?from=get-started`}>
            <Button
              small
              variant='block'
              color='primary'
              className='w-[139px] h-[41px] mt-8 text-sm'>
              Proceed
            </Button>
          </Link>
        </div>
      }>
      <div>
        <div className=' gradient_container absolute top-0 left-0 w-full h-[200px]'>
          <div className='flex justify-center  items-center h-full'>
            <div className='disable-blur p-4 rounded-xl  '>
              <AssignModalIcon />
            </div>
          </div>
          <div className='opacity-40 bottom-0 h-20'></div>
        </div>
        <div className='mt-[184px]'>
          <div className=''>
            <p className='text-[20px] font-semibold'>Assign Admin</p>
            <p className='text-[#5E6164] text-sm'>
              Assign up to 10 admins to oversee your dashboard
            </p>
          </div>
          <div className=''>
            {info.map((item, index) => (
              <div key={index} className='flex gap-2 py-4 '>
                <Pointer />
                <p className='text-sm font-normal text-[#2E3031]'>{item}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </LocalModal>
  );
};

export default AssignAdminModal;
